import { Spinner } from 'react-bootstrap';
import Layout from '../pages/Layout/Layout';
import FeatureUnavailable from '../components/activation/FeatureUnavailable';
import { useEntitlements } from '../hooks/useEntitlements';

/**
 * Route-level pre-call guard. When the package EXPLICITLY lacks `feature`
 * (flag === false) the page is never mounted - so none of its queries run - and the
 * calm card is shown inside the normal shell. A missing flag, a true flag and
 * restaurant accounts render the page exactly as before.
 *
 * This is not FeatureGate: it never replaces FeatureLocked and never blocks on a
 * missing key.
 */
export default function EntitlementGuard({ feature, children }) {
  const { ready, has } = useEntitlements();
  if (!ready) {
    return (
      <div className="flex w-full h-[60vh] items-center justify-center">
        <Spinner as="span" variant="primary" animation="border" role="status" aria-hidden="true" />
      </div>
    );
  }
  if (!has(feature)) {
    return (
      <Layout padding={false}>
        <FeatureUnavailable />
      </Layout>
    );
  }
  return children;
}
